import { c as _c } from "react/compiler-runtime";
import { postOrgRolesMutation } from '@onefootprint/fetch-dashboard';
import { getErrorMessage } from '@onefootprint/request/src/request';
import type { CreateTenantRoleRequest, TenantRoleKindDiscriminant } from '@onefootprint/request-types/dashboard';
import { Dialog, useToast } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import useInvalidateQueries from '@/hooks/use-invalidate-queries';
import Form from './components/role-form';
type CreateDialogProps = {
  open: boolean;
  onClose: () => void;
  kind: TenantRoleKindDiscriminant;
  /**
   * Opt-in for the dashboard team-role flow, where the admin chooses between a dashboard-user and an
   * auditor role. The API-key roles screen omits it so it can only ever create `api_key` roles.
   */
  allowKindSelection?: boolean;
};
const CreateDialog = t0 => {
  const $ = _c(31);
  const {
    open,
    onClose,
    kind,
    allowKindSelection: t1
  } = t0;
  const allowKindSelection = t1 === undefined ? false : t1;
  const {
    t: allT
  } = useTranslation("common");
  const {
    t: rolesT
  } = useTranslation("roles");
  const {
    toast
  } = useToast();
  const invalidateQueries = useInvalidateQueries();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = postOrgRolesMutation();
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const createRoleMutation = useMutation(t2);
  let t3;
  if ($[1] !== createRoleMutation || $[2] !== invalidateQueries || $[3] !== onClose || $[4] !== rolesT || $[5] !== toast) {
    t3 = payload => {
      createRoleMutation.mutate({
        body: payload
      }, {
        onError: error => {
          toast({
            title: rolesT(_temp),
            description: getErrorMessage(error),
            variant: "error"
          });
        },
        onSuccess: response => {
          toast({
            title: rolesT(_temp2),
            description: rolesT(_temp3, {
              name: response.name
            })
          });
          invalidateQueries();
          onClose();
        }
      });
    };
    $[1] = createRoleMutation;
    $[2] = invalidateQueries;
    $[3] = onClose;
    $[4] = rolesT;
    $[5] = toast;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleSubmit = t3;
  let t4;
  if ($[7] !== rolesT) {
    t4 = rolesT(_temp4);
    $[7] = rolesT;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== allT) {
    t5 = allT(_temp5);
    $[9] = allT;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== createRoleMutation.isPending || $[12] !== t5) {
    t6 = {
      form: "roles-form",
      label: t5,
      loading: createRoleMutation.isPending,
      type: "submit"
    };
    $[11] = createRoleMutation.isPending;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = createRoleMutation.isPending;
  let t8;
  if ($[14] !== allT) {
    t8 = allT(_temp6);
    $[14] = allT;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== createRoleMutation.isPending || $[17] !== onClose || $[18] !== t8) {
    t9 = {
      disabled: t7,
      label: t8,
      onClick: onClose
    };
    $[16] = createRoleMutation.isPending;
    $[17] = onClose;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== allowKindSelection || $[21] !== handleSubmit || $[22] !== kind) {
    t10 = <Form onSubmit={handleSubmit} kind={kind} allowKindSelection={allowKindSelection} />;
    $[20] = allowKindSelection;
    $[21] = handleSubmit;
    $[22] = kind;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== onClose || $[25] !== open || $[26] !== t10 || $[27] !== t4 || $[28] !== t6 || $[29] !== t9) {
    t11 = <Dialog onClose={onClose} open={open} size="large" title={t4} primaryButton={t6} secondaryButton={t9}>{t10}</Dialog>;
    $[24] = onClose;
    $[25] = open;
    $[26] = t10;
    $[27] = t4;
    $[28] = t6;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
};
export type { CreateDialogProps };
export default CreateDialog;
function _temp($) {
  return $.create.notifications.error.title;
}
function _temp2($_0) {
  return $_0.create.notifications.success.title;
}
function _temp3($_1) {
  return $_1.create.notifications.success.description;
}
function _temp4($_2) {
  return $_2.create.title;
}
function _temp5($_3) {
  return $_3.create;
}
function _temp6($_4) {
  return $_4.cancel;
}